import * as React from "react";

import { Header, Navigation, Footer, Filter } from "../../shared";
import { AdministrationMenu } from "../shared/menu/AdministrationMenu";
import "./Analytics.scss";

import {
    Grid,
    Paper,
    Snackbar,
    SnackbarContent,
    Tab,
    Tabs,
    Typography
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import { Users } from './tabs/users/Users';
import { AnalyticsGroupFilter } from "./shared/filters/AnalyticsGroupFilter";
import { AnalyticsProviderFilter } from "./shared/filters/AnalyticsProviderFilter";
import { AnalyticsFilterChip } from "./shared/chips/AnalyticsFilterChips";

const styles = {
    textField: {
      marginLeft: 5,
      marginRight: 5,
    },
};

function TabContainer(props: any) {
    return (
        <Typography component="div" style={{ paddingTop: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

function LinkTab(props: any) {
    return (
      // tslint:disable-next-line:jsx-no-lambda
      <Tab className="marketTab" onClick={event => event.preventDefault()} {...props} />
    );
}

// tslint:disable-next-line:no-empty-interface
export interface IAnalyticsProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IAnalyticsState {
    alertMessage: string,
    alertOpened: boolean,
    alertType: string,
    endDate: any,
    initialDate: any,
    tabValue: number;
}

export class Analytics extends React.Component<IAnalyticsProps, IAnalyticsState> {

    constructor(props: IAnalyticsProps) {
        super(props);

        this.state = {
            alertMessage: '',
            alertOpened: false,
            alertType: 'success',
            endDate: undefined,
            initialDate: undefined,
            tabValue: 0
        }
        this.errorMessage = this.errorMessage.bind(this);
        this.openAlert = this.openAlert.bind(this);
    }
    
    public render() {
        const filters = [
            <AnalyticsGroupFilter key={1} />,
            <AnalyticsProviderFilter key={3} />
        ];

        return (
        <div className="analytics-page">
            <Header title={"Dados de Acessos"} name={"Administrativo"} link={"/dashboard"} />

            <Navigation name={"Dados de Acessos"}
                linkDefault={"/administration/analytics"}
                link={"/dashboard"}
                linkTitle={"Produtos"}
                painel={3}
                icon={<ChevronRightIcon />}
            />

            <div className="analytics-body">
                <AdministrationMenu paramIcon={null} />

                <Filter filters={filters} />
                <AnalyticsFilterChip />
                <div className="wrapper">
                    <Grid
                        container={true}
                        className="analytics-panel analytics-grid"
                        spacing={16}
                    >
                        <Grid item={true} xs={12} >
                            <div>
                                <Paper>
                                    <Grid container={true} direction="column" spacing={16}>
                                        <Grid item={true}>
                                            <Snackbar
                                                anchorOrigin={{
                                                    horizontal: 'center',
                                                    vertical: 'center',
                                                }}
                                                open={this.state.alertOpened}
                                                autoHideDuration={4000}
                                                onClose={this.closeAlert}
                                            >
                                                <SnackbarContent message={this.state.alertMessage} style={this.alertStyle()}/>
                                            </Snackbar>
                                            <Tabs fullWidth={true} value={this.state.tabValue} onChange={this.handleChangeTab} 
                                                    centered={true} textColor="primary" indicatorColor="primary" className="tabs-analytics">
                                                    <LinkTab label="Lista" />
                                            </Tabs>
                                            {this.state.tabValue === 0 && <TabContainer>
                                                {<Users errorMessage={this.errorMessage} />}
                                            </TabContainer>}
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
            <div className="analytical-footer">
                <Footer />
            </div>
        </div>
        );
    }

    /**
     * Métodos gerenciamento das abas
     */
    private handleChangeTab = (event: any, tabValue: any) => {
        this.setState({ tabValue });
        event.stopPropagation();
    };

    /**
     * Métodos mensagem de alert
     */
    private alertStyle = () => {
        return styles[this.state.alertType];
    }

    private errorMessage(msg: string) {
        this.openAlert(true, 'error', msg || 'Falha ao salvar registro.');
    }

    private openAlert(alertOpened: boolean, alertType: string, alertMessage: string) {
        this.setState({ alertType })
        this.setState({ alertMessage })
        this.setState({ alertOpened })
    }

    private closeAlert = (event: object, reason: string) => {
        if (reason === 'clickaway') {
            return;
        }
        this.setState({ alertOpened: false });
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/analytics/Analytics.tsx